var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.article.title))]),_vm._v(" "),_c('div',{staticClass:"article-body",domProps:{"innerHTML":_vm._s(_vm.article.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }